/* ============
 * Password Transformer
 * ============
 *
 * The transformer for the password.
 */

import Transformer from './transformer';

export default class PasswordTransformer extends Transformer {
  static fetch(password) {
    return {
      currentPassword: password.current_password,
      password: password.password,
    };
  }

  static send(password) {
    return {
      current_password: password.currentPassword,
      password: password.password,
      password_confirmation: password.passwordConfirmation,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/password.js